module.exports = __webpack_public_path__ + "static/media/Notifica_biblioteca.176f1dbb.png";